import React from 'react';
import { DatePicker as AntdDatePicker, DatePickerProps as AntdDatePickerProps } from 'antd';

export type DatePickerProps = AntdDatePickerProps & {
	status?: '' | 'warning' | 'error';
	dropdownClassName?: string;
	popupClassName?: string;
};

const DatePicker: React.FunctionComponent<DatePickerProps> = (props: DatePickerProps) => <AntdDatePicker {...props} />;

export default DatePicker;
